/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JSResourceForInteraction } from '@atlassian/react-async';

type AssetsDataManagerDiscoverEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const assetsDataManagerDiscoverEntryPoint: EntryPoint<
	AssetsDataManagerDiscoverEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<AssetsDataManagerDiscoverEntryPointComponent>(
		/* webpackChunkName: "async-assets-data-manager-discover" */ './DataManagerDiscoverSpa.tsx',
	),
	getPreloadProps: () => ({}),
});
